import GetTest from "./GetTest";

export default GetTest;
